export const sessionIdSelector = (state) => state.getIn(['authorization', 'sessionId'])
export const uniqueIdSelector = (state) => state.getIn(['authorization', 'uniqueId'])
export const activeEntityStackTabSelector = (state) => state.getIn(['ui', 'entityStack', 'tabs', 'activeTab'])
export const isModuleAvailable = (state, module) =>
    state.getIn(['authorization', 'accessRights', module, 'available'], false)
